
// --- FILE: src/components/common/LoadingSpinner.jsx ---
import React from 'react';
import { Loader2 } from 'lucide-react';

const LoadingSpinner = ({ text, fullScreen = false }) => {
  if (fullScreen) {
    return (
      <div className="flex flex-col items-center justify-center min-h-screen bg-gray-100">
        <Loader2 className="w-12 h-12 text-blue-600 animate-spin" />
        {text && <p className="mt-4 text-gray-600">{text}</p>}
      </div>
    );
  }
  return (
    <div className="flex items-center justify-center space-x-2">
      <Loader2 className="w-5 h-5 animate-spin" />
      {text && <span>{text}</span>}
    </div>
  );
};
export default LoadingSpinner;